import React, { useState, useEffect, useRef } from "react";
import { fetchWithAuth, useUser } from "../Context/UserContext";
import PageLayout from "../components/layout/PageLayout";
import FiltroCatalogo from "./FiltroCatalogo";
import InfoCatalogo from "./InfoCatalogo";
import ModalContacto from "./ModalContacto";
import { TopProgressBar } from "../components/ui/progress-bar";
import API_URL from "../config"; // ✅ Importa la URL del backend
import { Helmet } from "react-helmet-async";

const Catalogo = () => {
  console.log("entrando a catalogo?s");
  const { user } = useUser();
  const [empresas, setEmpresas] = useState([]);
  const [filters, setFilters] = useState({
    categoria: [], // Permite múltiples categorías
    ciudad: [],
    puntaje: "",
    certificado: false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedEmpresa, setSelectedEmpresa] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  const [favoritosIds, setFavoritosIds] = useState(new Set());
  const catalogRef = useRef(null);

  const fetchFavoritos = async () => {
    try {
      const response = await fetchWithAuth(`${API_URL}/catalogo/favoritos`);
      if (response.ok) {
        const { empresas: favoritos } = await response.json();
        setFavoritosIds(new Set(favoritos.map((e) => e.id_company)));
      }
    } catch (error) {
      console.error("❌ Error al obtener favoritos:", error);
    }
  };

  const handleToggleFavorito = async (empresa) => {
    const esFavorito = favoritosIds.has(empresa.id_company);
    try {
      const response = await fetchWithAuth(
        `${API_URL}/catalogo/favoritos/${empresa.id_company}`,
        { method: esFavorito ? "DELETE" : "POST" }
      );
      if (response.ok) {
        setFavoritosIds((prev) => {
          const next = new Set(prev);
          if (esFavorito) {
            next.delete(empresa.id_company);
          } else {
            next.add(empresa.id_company);
          }
          return next;
        });
      }
    } catch (error) {
      console.error("❌ Error al actualizar favorito:", error);
    }
  };

  useEffect(() => {
    fetchEmpresas(page, filters);
  }, [page, filters]);

  useEffect(() => {
    if (user) {
      fetchFavoritos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const fetchEmpresas = async (page, filters) => {
    console.log(
      "🟡 [Catalogo] Estado de filters antes de la petición:",
      filters
    );

    setIsLoading(true);

    try {
      const params = new URLSearchParams({
        page,
        ...(filters.categoria.length > 0 && {
          categoria: filters.categoria.map((cat) => cat.trim()).join(","), // Convertir a string plano
        }),
        ...(filters.ciudad.length > 0 && { ciudad: filters.ciudad.join(",") }),

        ...(filters.puntaje && { puntaje: filters.puntaje }), // ✅ Asegura que se envía como string numérico
        ...(filters.certificado && { certificado: "true" }),
      });

      console.log(
        "🔵 [Catalogo] Parámetros enviados en la URL:",
        params.toString()
      );

      const response = await fetchWithAuth(
        `${API_URL}/catalogo/empresas?${params.toString()}`,
        { public: true }
      );

      if (response.ok) {
        const { empresas, pages } = await response.json();
        setEmpresas(empresas);
        setTotalPages(pages);
      } else {
        console.error(
          "❌ Error al obtener empresas",
          response.statusText,
          response.error
        );
      }
    } catch (error) {
      console.error("❌ Error al obtener empresas:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleOpenContactModal = (empresa) => {
    setSelectedEmpresa(empresa);
    setShowContactModal(true);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
    setSelectedEmpresa(null);
  };

  const clearFilters = () => {
    setFilters({
      categoria: [], // ✅ Mantiene formato de array vacío
      ciudad: [], // ✅ Mantiene formato de array vacío
      puntaje: "", // ✅ Se mantiene como string vacío
      certificado: false,
    });
    setPage(1);
  };

  return (
    <PageLayout>
      <Helmet>
        <title>Catálogo de Proveedores - Procu</title>
        <meta
          name="description"
          content="Explora el catálogo de proveedores en Procu. Encuentra empresas confiables para tus proyectos y accede a oportunidades de negocio."
        />
        <meta name="keywords" content="catálogo, proveedores, negocios, empresas, licitaciones, B2B, Procu" />
      </Helmet>

      <TopProgressBar isLoading={isLoading} />

      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6" ref={catalogRef}>
        <FiltroCatalogo
          filters={filters}
          setFilters={setFilters}
          setPage={setPage}
          clearFilters={clearFilters}
        />
        <InfoCatalogo
          empresas={empresas}
          page={page}
          totalPages={totalPages}
          setPage={setPage}
          onContact={(empresa) => handleOpenContactModal(empresa)}
          onNextPage={handleNextPage}
          onPreviousPage={handlePreviousPage}
          clearFilters={clearFilters}
          favoritosIds={favoritosIds}
          onToggleFavorito={handleToggleFavorito}
        />
      </div>

      <ModalContacto
        show={showContactModal}
        onClose={handleCloseContactModal}
        empresa={selectedEmpresa}
      />
    </PageLayout>
  );
};

export default Catalogo;
